import { ContactUsMessageExtraDataModel } from "../External/FeedbackModel"

export enum ModalViewName {
    keys = "KEYS",
    billing = "BILLING",
    addMyRequest = "ADD_MY_REQUEST",
    newsletterSubscription = "NEWSLETTER_SUBSCRIPTION",
    askIfReviewJobOutput = "ASK_IF_REVIEW_JOB_OUTPUT",
    contactForm = "CONTACT_FORM"
}

export interface KeysModalView {
    type: ModalViewName.keys
}

export interface BillingModalView {
    type: ModalViewName.billing
}

export interface AddMyRequestModalView {
    type: ModalViewName.addMyRequest
    templateID: string
}

export interface NewsletterSubscriptionModalView {
    type: ModalViewName.newsletterSubscription
}

export interface AskIfReviewJobOutputModalView {
    type: ModalViewName.askIfReviewJobOutput
}

export interface ContactFormModalView {
    type: ModalViewName.contactForm
    prefilledMessage?: string
    extraData: ContactUsMessageExtraDataModel
}

export type SimpleModalView =
    | KeysModalView
    | BillingModalView
    | NewsletterSubscriptionModalView
    | AskIfReviewJobOutputModalView
    | ContactFormModalView

export type ModalView = SimpleModalView | AddMyRequestModalView
